import { cn } from "@theprelude/core";

export const PasswordIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9998 5.33464H13.3331C13.7013 5.33464 13.9998 5.63312 13.9998 6.0013V14.0013C13.9998 14.3695 13.7013 14.668 13.3331 14.668H2.66666C2.29847 14.668 2 14.3695 2 14.0013V6.0013C2 5.63312 2.29847 5.33464 2.66666 5.33464H3.99997V4.66797C3.99997 2.45883 5.7908 0.667969 7.9999 0.667969C10.209 0.667969 11.9998 2.45883 11.9998 4.66797V5.33464ZM3.33331 6.66797V13.3346H12.6665V6.66797H3.33331ZM7.33324 9.33464H8.66655V10.668H7.33324V9.33464ZM4.66662 9.33464H5.99993V10.668H4.66662V9.33464ZM9.99986 9.33464H11.3332V10.668H9.99986V9.33464ZM10.6665 5.33464V4.66797C10.6665 3.19521 9.47261 2.0013 7.9999 2.0013C6.52716 2.0013 5.33328 3.19521 5.33328 4.66797V5.33464H10.6665Z" />
  </svg>
);
